export default "__VITE_ASSET__BwflDXY1__"